document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.video-slider').forEach(function (slider) {
    var sectionId = slider.dataset.sectionId;
    var track = document.getElementById('VideoSliderTrack-' + sectionId);
    var progress = document.getElementById('VideoSliderProgress-' + sectionId);
    if (!track || !progress) return;

    function updateProgress() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 0) {
        progress.style.width = '100%';
        progress.style.transform = 'translateX(0)';
        return;
      }
      var visibleRatio = track.clientWidth / track.scrollWidth;
      var travel = 100 - visibleRatio * 100;
      var scrolled = track.scrollLeft / maxScroll;
      progress.style.width = (visibleRatio * 100) + '%';
      progress.style.transform = 'translateX(' + (scrolled * travel) + '%)';
    }

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateProgress);
    }, { passive: true });

    window.addEventListener('resize', updateProgress);
    updateProgress();

    // Pause off-screen videos, play the most visible one if autoplay is set.
    var videos = track.querySelectorAll('video');
    if ('IntersectionObserver' in window && videos.length) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      }, { root: track, threshold: [0, 0.6, 1] });

      videos.forEach(function (video) {
        observer.observe(video);
      });
    }

    // Mute toggle buttons
    track.querySelectorAll('.video-slider__mute-toggle').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var video = btn.closest('.video-slider__media').querySelector('video');
        if (video) video.muted = !video.muted;
      });
    });
  });
});
